import { useNavigation } from '@/pages/auth/sign-up/hooks/useNavigation';

import { VerifyPhoneFormBase } from './VerifyPhoneFormBase';

export const VerifyPhoneForm = () => {
  const navigation = useNavigation();

  return (
    <VerifyPhoneFormBase
      goToNextStep={navigation.goToNextStep}
      goToPreviousStep={navigation.goToPreviousStep}
      currentStep={navigation.currentStepIndex + 1}
      totalSteps={navigation.totalSteps}
    />
  );
};
